import {
  serializeStack,
  TROWSER_PARAM,
  TrowserKey,
} from '@/modules/navigation/trowsers/trowser.types';
import { ROUTE_KEYS } from '@/navigation/constants';
import { getCompletePathFromRouteKey } from '@/navigation/navigationUtils';

export function getValidationQuestionsPath(householdId: string) {
  return getCompletePathFromRouteKey(
    ROUTE_KEYS.HOUSEHOLD_DETAILS_OVERVIEW,
    { householdId },
    {
      [TROWSER_PARAM]: serializeStack([
        { key: TrowserKey.ValidationQuestions, target: householdId },
      ]),
    }
  );
}
